Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeVideoContentParser

  parse: (serializedSocialContent) ->
    youtubeVideo = new Monitoring.Models.SocialContents.YoutubeVideoParser().parse(serializedSocialContent)
    youtubeIntegrationId = serializedSocialContent.youtubeIntegrationId
    isListening = serializedSocialContent.isListening
    return new Monitoring.Models.SocialContents.YoutubeVideoContent(youtubeVideo, youtubeIntegrationId, isListening)
